import { SearchableUser } from '../../../iam/models/SearchableUser'
import { Id } from '../../../types/definitions'
import { observer } from 'mobx-react'
import {
  CheckboxCell,
  DateCell,
  ImageCell,
  TableCell,
  TextCell,
} from '../../../components/Table'
import Pill from '../../../components/Pill'
import { Dropdown, DropdownTitle } from '../../../components/Dropdown'
import { IconButton } from '../../../components/IconButton'
import Icon from '../../../components/Icon'
import React from 'react'

interface UserManagementTableRowProps {
  user: SearchableUser
  isSelected: (publicId: Id) => boolean
  toggleRow: (checked: boolean, publicId: Id) => void
}

export default observer(
  ({ user, isSelected, toggleRow }: UserManagementTableRowProps) => (
    <>
      <CheckboxCell
        checked={isSelected(user.publicId)}
        onChange={(checked) => toggleRow(checked, user.publicId)}
      />

      <ImageCell key={user.publicId} title={user.displayName}></ImageCell>

      <TextCell>{user.email}</TextCell>

      <TableCell>
        {user.userDataType && <Pill>{user.userDataType}</Pill>}
      </TableCell>

      <DateCell date={user.lastSeen}></DateCell>

      <DateCell date={user.dateCreated}></DateCell>

      <TableCell>
        <Dropdown
          autoDismiss
          position="bottom-end"
          button={
            <IconButton>
              <Icon name={'more'}></Icon>
            </IconButton>
          }
        >
          <DropdownTitle>Actions</DropdownTitle>
        </Dropdown>
      </TableCell>
    </>
  )
)
